import { render, staticRenderFns } from "./SliderPanel.vue?vue&type=template&id=5116353b&scoped=true&"
import script from "./SliderPanel.vue?vue&type=script&lang=ts&"
export * from "./SliderPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116353b",
  null
  
)

export default component.exports